import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  importProvidersFrom
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@services/auth.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { QUOTE_REPOSITORY_TOKEN } from '@domain/repositories/quote.repository.token';
import { QuoteRepositoryImpl } from '@infra/repositories/quote.repository.impl';
import { CONTRACT_REPOSITORY_TOKEN } from '@domain/repositories/contract.repository.token';
import { ContractRepositoryImpl } from '@infra/repositories/contract.repository.impl';
import { WORK_REPOSITORY_TOKEN } from '@domain/repositories/work.repository.token';
import { WorkRepositoryImpl } from '@infra/repositories/work.repository.impl';
import { CONTRACTOR_REPOSITORY_TOKEN } from '@domain/repositories/contractor.repository.token';
import { ContractorRepositoryImpl } from '@infra/repositories/contractor.repository.impl';
import { NOTIFICATION_REPOSITORY_TOKEN } from '@domain/repositories/notification.repository.token';
import { NotificationRepositoryImpl } from '@infra/repositories/notification.repository.impl';
import { MULTIMEDIA_REPOSITORY_TOKEN } from '@domain/repositories/multimedia.repository.token';
import { MultimediaRepositoryImpl } from '@infra/repositories/multimedia.repository.impl';
import { PRODUCT_REPOSITORY_TOKEN } from '@domain/repositories/product.repository.token';
import { ProductRepositoryImpl } from '@infra/repositories/product.repository.impl';
import { USER_REPOSITORY_TOKEN } from '@domain/repositories/user.repository.token';
import { UserRepositoryImpl } from '@infra/repositories/user.repository.impl';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),
    provideClientHydration(withEventReplay()),
    importProvidersFrom(HttpClientModule),
    importProvidersFrom(FormsModule),
    provideHttpClient(withInterceptors([authInterceptor])),
    // Clean Architecture: Inyección de repositorios
    {
      provide: QUOTE_REPOSITORY_TOKEN,
      useClass: QuoteRepositoryImpl
    },
    {
      provide: CONTRACT_REPOSITORY_TOKEN,
      useClass: ContractRepositoryImpl
    },
    {
      provide: WORK_REPOSITORY_TOKEN,
      useClass: WorkRepositoryImpl
    },
    {
      provide: CONTRACTOR_REPOSITORY_TOKEN,
      useClass: ContractorRepositoryImpl
    },
    {
      provide: NOTIFICATION_REPOSITORY_TOKEN,
      useClass: NotificationRepositoryImpl
    },
    {
      provide: MULTIMEDIA_REPOSITORY_TOKEN,
      useClass: MultimediaRepositoryImpl
    },
    {
      provide: PRODUCT_REPOSITORY_TOKEN,
      useClass: ProductRepositoryImpl
    },
    {
      provide: USER_REPOSITORY_TOKEN,
      useClass: UserRepositoryImpl
    }
  ]
};
